export enum StoreLoadingStatus {
	INITIAL = 'initial',
	LOADING = 'loading',
	LOADED = 'loaded',
}
